














import {Component, Vue} from "vue-property-decorator";
import NotificationListView from "@/components/Dashboard/Notification/NotificationListView.vue";
@Component({
  components: {NotificationListView}
})
export default class Notifications extends Vue {
  public title = "اطلاع رسانی‌ها";

  mounted(){
    window.scrollTo(0,0);
  }
}
